module.exports = __webpack_public_path__ + "img/Lock-icon.e1462312.png";